import { FETCH_DASHBOARD_DATA } from "./dashboard-store-constants";

const initialState = {
  dashboardData: {
    Today_Response: 0,
    Week_Response: 0,
    Total_Response: 0,
    No_Of_Question: 0,
    chart: [],
    data: []
  }
};

export const DashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: action.payload.dashboardData
      };
    default:
      return state;
  }
};
